import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Index',
            component: function () {
                return import('./views/Index.vue')
            },
        },
        {
            path: '/aanmelden-trial-versie',
            name: 'AanmeldenTrial',
            component: function () {
                return import('./views/Trial.vue')
            },
        },
    ]
});



export default router
